import React, { Component } from "react";
import { Link } from "react-router-dom";
import MobileMenu from "./MobileMenu";
import MobileMenuEn from "./MobileMenuEn";
class NavBarEn extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.handleScroll = this.handleScroll.bind(this);

    this.mobileMenuElement = React.createRef();
  }

  activeMobileMenu = () => {
    this.mobileMenuElement.current.toggleMobileMenu();
  };

  handleScroll() {
    if (this.mount) {
      this.setState({ scroll: window.scrollY });
    }
  }

  componentDidMount() {
    this.mount = true;
    const el = document.querySelector("nav");
    this.setState({ top: el.offsetTop, height: el.offsetHeight });
    window.addEventListener("scroll", this.handleScroll);
  }

  componentDidUpdate() {
    this.state.scroll > this.state.top
      ? (document.body.style.paddingTop = `${this.state.height}px`)
      : (document.body.style.paddingTop = 0);
  }

  componentWillUnmount() {
    this.mount = false;
  }

  render() {
    return (
      <div>
        {/*====================  header area ====================*/}
        <div
          className={`header-area header-sticky header-sticky--default ${
            this.state.scroll > this.state.top ? "is-sticky" : ""
          }`}
        >
          <div className="header-area__desktop header-area__desktop--default">
            {/*=======  header info area  =======*/}
            <div className="header-info-area">
              <div className="container">
                <div className="row align-items-center">
                  <div className="col-lg-12">
                    <div className="header-info-wrapper align-items-center">
                      {/* logo */}
                      <div className="logo">
                        <Link to={`${process.env.PUBLIC_URL}/`}>
                          <img
                            src="assets/img/logo/logo-lateral.png"
                            className="img-fluid"
                            alt="Logo"
                          />
                        </Link>
                      </div>
                      {/* header contact info */}
                      <div className="header-contact-info">
                        <div className="header-info-single-item">
                          <div className="header-info-single-item__icon">
                            <i className="zmdi zmdi-smartphone-android" />
                          </div>
                          <div className="header-info-single-item__content">
                            <h6 className="header-info-single-item__title">
                              Phone
                            </h6>
                            <p href = "" className="header-info-single-item__subtitle">
                              +52 (656) 552 7143
                            </p>
                          <img
                            src="assets/img/logo/whats.png"
                            /> 
                             <p className="header-info-single-item__subtitle">
                              +52 (656) 199-4312
                            </p>
                          </div>
                          
                        </div>
                        <div className="header-info-single-item">
                          <div className="header-info-single-item__icon">
                            <i className="zmdi zmdi-home" />
                          </div>
                          <div className="header-info-single-item__content">
                            <h6 className="header-info-single-item__title">
                              Address   
                            </h6>
                            <p className="header-info-single-item__subtitle">
                              Calle Valle de las Torres No. 8598,<br></br>
                              Colonia Valle del Bravo Cd Juarez<br></br>{" "}
                              Chihuahua CP: 32695.
                            </p>
                          </div>
                        </div>
                        <div className="header-info-single-item__content">
                            <h6 className="header-info-single-item__title">
                            Language
                            </h6>
                            <p className="header-info-single-item__subtitle">
                              <a href = "/">Spanish</a>{" / "}{" "}
                              <a href = "/Home">English</a><br></br>{" "}
                            </p>
                          </div>
                      </div>
                      {/* mobile menu */}
                      <div className="mobile-navigation" >
                        <p className="header-info-single-item__subtitle">
                          <a href = "/">Español</a>{" / "}
                          <a href = "/Home">English</a>
                        </p>
                      </div>
                      <div
                        className="mobile-navigation-icon"
                        id="mobile-menu-trigger"
                        onClick={this.activeMobileMenu}
                      
                      >
                       
                        <i />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/*=======  End of header info area =======*/}
            {/*=======  header navigation area  =======*/}
            <div className="header-navigation-area default-bg">
              <div className="container">
                <div className="row">
                <div className="col-lg-12">
                    {/* header navigation */}
                    <div className="header-navigation header-navigation--header-default position-relative">
                      <div className="header-navigation__nav ">
                        <nav>
                          <ul >
                            <li>
                              <Link to={`${process.env.PUBLIC_URL}/`}>
                                {" "}
                                HOME{" "}
                              </Link>
                            </li>
                            <li>
                              <Link to={`${process.env.PUBLIC_URL}/us`}>
                                US
                              </Link>
                            </li>

                            <li className="has-children has-children--multilevel-submenu">
                              <Link to={`${process.env.PUBLIC_URL}/Equipment`}>
                                EQUIPMENT
                              </Link>
                              <ul className="submenu">
                                <li>
                                  <Link
                                    to={`${process.env.PUBLIC_URL}/Crusher`}
                                  >
                                    Crusher
                                  </Link>
                                </li>
                                <li>
                                  <Link
                                    to={`${process.env.PUBLIC_URL}/Vibrating-Screen`}
                                  >
                                    Vibrating Screen
                                  </Link>
                                </li>
                                <li>
                                  <Link
                                    to={`${process.env.PUBLIC_URL}/Molinos`}
                                  >
                                    Mill
                                  </Link>
                                </li>
                                <li>
                                  <Link
                                    to={`${process.env.PUBLIC_URL}/flotacion`}
                                  >
                                    Flotation
                                  </Link>
                                </li>
                                <li>
                                  <Link
                                    to={`${process.env.PUBLIC_URL}/Bombeo`}
                                  >
                                    Pumping
                                  </Link>
                                </li>
                                <li>
                                  <Link
                                    to={`${process.env.PUBLIC_URL}/filtracion`}
                                  >
                                    Filters
                                  </Link>
                                </li>
                                <li>
                                  <Link
                                    to={`${process.env.PUBLIC_URL}/refacciones`}
                                  >
                                    Spare parts
                                  </Link>
                                </li>
                                <li>
                                  <Link
                                    to={`${process.env.PUBLIC_URL}/Plantas`}
                                  >
                                    Complete Plants
                                  </Link>
                                </li>
                              </ul>
                            </li>
                            <li>
                              <Link to={`${process.env.PUBLIC_URL}/contact-us-en`}>
                                CONTACT
                              </Link>
                            </li>
                          </ul>
                        </nav>
                      </div>
                    </div>
                </div>
                </div>
              </div>
            </div>
            {/*=======  End of header navigation area =======*/}
          </div>
        </div>
        {/*====================  End of header area  ====================*/}

        {/* Mobile Menu */}
        <MobileMenuEn ref={this.mobileMenuElement} />
      </div>
    );
  }
}

export default NavBarEn;
